import { Component, TemplateRef, ViewChild } from '@angular/core';
import { I18NService } from '../../shared/i18n/i18n.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { IPlaceValuelistService } from '../../iPlace/iPlace-valuelist.service';
import { TankService } from '../ipetrol/Tank.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { ManualTransactionsService } from './manualTransactions.service';
import { Globals } from '../../globals';
import { ItemTagType } from '../tag/Tag';
import { TagService } from '../tag/Tag.service';
import { ManualTransaction } from './ManualTransaction';

@Component({
  templateUrl: './manualTransactions.component.html',
  styleUrls: ['./manualTransactions.component.css']
})
export class ManualTransactionsComponent {

  isLoading = false;
  tableMessages: any;
  dropdownList: any = [];
  iPlaceList: any[] = [];
  iPlaceMap: any[];
  itemTags: any[] = [];
  selectedItems: any = [];
  selectedFormItems:any = [];
  dropdownSettings: any = {};
  formDropdownSettings: any = {};
  bsConfig: Partial<BsDatepickerConfig>;
  dateRangeFilter:any;
  manualTransaction: ManualTransaction;
  manualTransactions: ManualTransaction[];
  rows: ManualTransaction[];
  creationDate: Date;
  productIds: string[] = ["90", "91", "92", "93", "94", "95", "97", "98", "99"];
  tranlatedProducts = {};
  tankMessage: string;

  @ViewChild('createTemplate', { static: true })
  private createTempRef : TemplateRef<any>;
  @ViewChild('confirmTemplate', { static: true })
  private confirmTemplateRef : TemplateRef<any>;
  @ViewChild('errorTemplate', { static: true })
  private errorTemplate : TemplateRef<any>;
  private flagCreate = false;
  modalRef: BsModalRef;
  confirmModalRef: BsModalRef;
  errorModalRef: BsModalRef;
  isLoadingManualTransaction = false;
  isCreatingManualTransaction = false;
  formInvalid = false;

  @ViewChild('multiSelect', { static: true }) element;

  constructor(
    private i18nService: I18NService,
    private modalService: BsModalService,
    private iPlaceValuelistService: IPlaceValuelistService,
    private tagService: TagService,
    private manualTransactionsService: ManualTransactionsService,
    private tankService: TankService,
    private globals: Globals
  ) {

    this.tableMessages = {};
    this.tableMessages.emptyMessage = this.i18nService.get("noDataToDisplay");
    this.tableMessages.totalMessage = this.i18nService.get("total");
    this.tableMessages.selectedMessage = this.i18nService.get("selected");
    this.tankMessage = this.i18nService.get("tank");

    this.productIds.forEach(productId => {
      this.tranlatedProducts[productId] = i18nService.get(productId);
    });

    if ( (<any> Object).values(this.iPlaceValuelistService.getValuelist()).length ) {
      this.iPlaceList = (<any>  Object).values(this.iPlaceValuelistService.getValuelist())
        .sort((a: any, b: any) => a.iPlaceName.localeCompare(b.iPlaceName));
      this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
        previous[current.id] = current;
        return previous;
      }, {});
    } else {
      this.iPlaceValuelistService.reload()
        .then( () => {
          this.iPlaceList = (<any> Object).values(this.iPlaceValuelistService.getValuelist())
            .sort((a:any, b:any) => a.iPlaceName.localeCompare(b.iPlaceName));
          this.iPlaceMap = this.iPlaceList.reduce((previous: any, current: any) => {
            previous[current.id] = current;
            return previous;
          }, {});
          if ( globals.tenant == "ecomanager" ) {
            this.setGroupedIPlaceList();
          } else {
            this.dropdownList = this.iPlaceList;
          }
        });
    }

    let groupBy = null;

    if ( globals.tenant == "ecomanager" ) {
      groupBy = "tag";
      this.tagService.getItemTags(ItemTagType.IPLACE)
        .then( itemTags => {
          this.itemTags = itemTags;
          this.setGroupedIPlaceList();
        });
    } else {
      this.dropdownList = this.iPlaceList;
    }

    this.dropdownSettings = {
      singleSelection: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      classes: "form-angular2-multiselect"
    };

    this.formDropdownSettings = {
      singleSelection: true,
      enableCheckAll: false,
      enableFilterSelectAll: false,
      primaryKey: 'idiPlace',
      labelKey: 'iPlaceName',
      selectAllText: i18nService.get("selectAll"),
      unSelectAllText: i18nService.get("unselectAll"),
      filterSelectAllText: i18nService.get("selectAllFiltered"),
      filterUnSelectAllText: i18nService.get("unselectAllFiltered"),
      noDataLabel: i18nService.get("noResults"),
      text: i18nService.get("selectStation"),
      searchPlaceholderText: i18nService.get("search"),
      badgeShowLimit: 2,
      enableSearchFilter: true,
      groupBy: groupBy,
      maxHeight:250,
      classes: "form-angular2-multiselect iplace-select"
    };

    this.bsConfig = Object.assign({}, {containerClass: "theme-custom", showWeekNumbers: false});

    let startDate = new Date();
    startDate.setHours(0,0,0,0);
    let endDate = new Date();
    endDate.setHours(0,0,0,0);
    endDate = new Date(endDate.getTime() - 604800000);
    this.dateRangeFilter = [endDate, startDate];
    this.creationDate = new Date();
  }

  reloadManualTransactions() {
    this.isLoading = true;
    let iPlaceIds = this.selectedItems.map(iplace => iplace.idiPlace)
      .join(";");
    let start = this.dateRangeFilter[0].getTime();
    let end = this.dateRangeFilter[1].getTime() + 86400000;
    this.manualTransactionsService.get(iPlaceIds, start, end)
      .then( list => {
        this.rows = list;
        this.isLoading = false;
        this.rows.forEach(manualTransaction => {
          manualTransaction.tankName = this.tankMessage + " " + manualTransaction.localTankId + ( manualTransaction.productId ?  " - " + this.tranlatedProducts[manualTransaction.productId] : "" );
        });
      })
      .catch( error => {
        this.isLoading = false;
      });
  }

  onItemSelect(item: any) {
    this.reloadManualTransactions();
  }

  onSelectAll(item: any) {
    this.reloadManualTransactions();
  }

  onDeSelectAll(item: any) {
    this.selectedItems = [];
    this.reloadManualTransactions();
  }

  onDateRangeChange(any: any) {
    this.reloadManualTransactions();
  }

  createManualTransaction() {
    this.flagCreate = true;
    //FIX for bug singleSelection & groupBy
    this.selectedFormItems = [{iPlaceName: this.i18nService.get("selectStation")}];
    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.formDropdownSettings.groupBy = false;
      }
    }

    this.modalRef = this.modalService.show(this.createTempRef);
  }

  onManualTransactionItemSelect(item: any) {
    this.manualTransactions = [];
    this.isLoadingManualTransaction = true;
    this.tankService.getProductTanks(item.idiPlace)
      .then( list => {
        this.isLoadingManualTransaction = false;
        let manualTransaction = [];
        list.forEach((tank:any) => {
          let tankName = this.i18nService.get("tank") + " " + tank.localTankId + ( tank.productId ?  " - " + this.i18nService.get(tank.productId) : "" );
          manualTransaction.push(new ManualTransaction(tank.iPlaceId, tank.localTankId, tank.tankId, tankName, tank.productId,null, false, this.creationDate.getTime(), null));
        });
        this.manualTransactions = manualTransaction.sort((a:any,b:any) => a.localTankId - b.localTankId);
    }).catch( error => {

    });
  }

  onManualTransactionItemDeselect(item: any) {
    this.manualTransactions = [];
  }

  registerManualTransaction() {
    let manualTransaction = Object.assign([], this.manualTransactions);
    this.checkValidData(manualTransaction);
    if ( !this.formInvalid ) {
      this.confirmModalRef = this.modalService.show(this.confirmTemplateRef, { class: 'confirm-create' });
      this.confirmModalRef.content = {
        manualTransaction: manualTransaction
      };
    }
  }

  confirmCreate() {
    this.isCreatingManualTransaction = true;
    this.manualTransactionsService.create(this.confirmModalRef.content.manualTransaction)
      .then( list => {
        this.hide();
        this.isCreatingManualTransaction = false;
        this.reloadManualTransactions();
      })
      .catch( error => {
         if ( (error.code && error.code == 1280) || error ) {
          this.errorModalRef = this.modalService.show(this.errorTemplate, { class: 'confirm-create' });
        }
      });
  }

  hide() {
    this.modalService.hide(1);
    this.flagCreate = false;
    this.manualTransactions = null;
    this.formInvalid = false;
    this.selectedFormItems = null;
    this.creationDate = new Date();
  }

  private checkValidData(manualTransactions) {
    let isBlank = true;
    manualTransactions.forEach(manualTransaction => {
      if( manualTransaction.sales == null || manualTransaction.sales.length < 1  ) isBlank = false;
      this.formInvalid = !(manualTransaction.iPlaceId
      && manualTransaction.creationDate
      && isBlank);
    });
  }

  onManualTransactionDateRangeChange(any: any) {
    if( this.manualTransactions.length > 0)
      this.manualTransactions.forEach(manualTransaction => {
        manualTransaction.creationDate = this.creationDate.getTime();
      });
  }

  private setGroupedIPlaceList() {
    if ( this.iPlaceMap ) {
      this.itemTags.forEach(itemTag => {
        let iplace = this.iPlaceMap[itemTag.id.itemId];
        if ( iplace && !iplace.tag ) {
          iplace.tag = itemTag.id.tagKey;
        }
      });
    }

    if ( this.iPlaceList.length ) {
      if ( !this.itemTags || !this.itemTags.length ) {
        this.element.settings.groupBy = false;
      }
    }

    this.dropdownList = this.iPlaceList.sort((a:any, b:any) => {
      if ( !a.tag ) {
        return -1
      } else if (a.tag == b.tag) {
        return a.iPlaceName.localeCompare(b.iPlaceName);
      } else {
        return a.tag.localeCompare(b.tag);
      }
    });
  }
}
